import React from 'react';

interface AscensionSplashProps {
  onEnter: () => void;
}

const AscensionSplash: React.FC<AscensionSplashProps> = ({ onEnter }) => {
  return (
    <div className="asc-root">
      <div className="asc-noise" />

      {/* 动态背景 */}
      <div className="asc-mystic-bg">
        <div className="asc-circle asc-circle-1" />
        <div className="asc-circle asc-circle-2" />
        <div className="asc-circle asc-circle-3">
          <div className="asc-vortex" />
          <div className="asc-scan" />
          <div className="asc-core-glow" />
          <div className="asc-core-mark">
            <span>命</span>
          </div>
          
          {/* 外圈慢速齿轮 */}
          <svg className="asc-gear asc-gear-slow" viewBox="0 0 200 200">
            <circle cx="100" cy="100" r="95" stroke="rgba(251,191,36,0.15)" strokeWidth="0.5" />
            {/* 齿轮的齿 */}
            <path d="M100 2 L100 8 M100 192 L100 198 M2 100 L8 100 M192 100 L198 100 M31 31 L35 35 M165 165 L169 169 M31 169 L35 165 M165 31 L169 35" stroke="rgba(251,191,36,0.4)" strokeWidth="1.5" strokeLinecap="round" />
            <circle cx="100" cy="100" r="85" stroke="rgba(251,191,36,0.2)" strokeWidth="1" strokeDasharray="3 6" />
          </svg>

          <svg className="asc-circle-3-orbit" viewBox="0 0 200 200">
            <circle cx="100" cy="100" r="92" />
            <circle cx="100" cy="100" r="76" strokeDasharray="1, 5" />
            <circle cx="100" cy="100" r="58" strokeDasharray="0.6, 9" />
            
            {/* 命运之网（连线） */}
            <path d="M100 8 L100 192 M8 100 L192 100 M35 35 L165 165 M35 165 L165 35" strokeOpacity="0.15" strokeWidth="0.3" />
            
            {/* 魔法阵六芒星 */}
            <path d="M100 25 L168 138 L32 138 Z" strokeOpacity="0.3" />
            <path d="M100 175 L32 62 L168 62 Z" strokeOpacity="0.3" />

            {/* 星辰节点与古老符号 */}
            <circle cx="100" cy="8" r="2" fill="rgba(251,191,36,0.6)" stroke="none" />
            <circle cx="168" cy="138" r="1.5" fill="rgba(251,191,36,0.5)" stroke="none" />
            <circle cx="32" cy="138" r="1.5" fill="rgba(251,191,36,0.5)" stroke="none" />
            <text x="96" y="22" fill="rgba(251,191,36,0.4)" fontSize="6" fontFamily="monospace" stroke="none">α</text>
            <text x="175" y="103" fill="rgba(251,191,36,0.4)" fontSize="6" fontFamily="monospace" stroke="none">Ω</text>
            <text x="20" y="103" fill="rgba(251,191,36,0.4)" fontSize="6" fontFamily="monospace" stroke="none">∞</text>
            <text x="96" y="185" fill="rgba(251,191,36,0.4)" fontSize="6" fontFamily="monospace" stroke="none">∆</text>
          </svg>

          {/* 内圈逆向齿轮 */}
          <svg className="asc-gear asc-gear-reverse" viewBox="0 0 200 200">
            <circle cx="100" cy="100" r="45" stroke="rgba(251,191,36,0.15)" strokeWidth="0.5" />
            <path d="M100 52 L100 55 M100 145 L100 148 M52 100 L55 100 M145 100 L148 100 M66 66 L68 68 M132 132 L134 134 M66 134 L68 132 M132 66 L134 68" stroke="rgba(251,191,36,0.3)" strokeWidth="1" strokeLinecap="round" />
            <circle cx="100" cy="100" r="35" stroke="rgba(251,191,36,0.2)" strokeWidth="0.5" strokeDasharray="2 4" />
          </svg>

          <div className="asc-rune-ring asc-rune-ring-outer">
            <span>日常</span><span>关系</span><span>心智</span><span>健康</span>
            <span>营养</span><span>行动</span><span>途径</span><span>泛灵</span>
          </div>
          <div className="asc-rune-ring asc-rune-ring-inner">
            <span>MBTI</span><span>SAN</span><span>EXP</span><span>AI</span>
          </div>
        </div>
        <div className="asc-line-v" />
        <div className="asc-line-h" />
      </div>

      {/* 漂浮粒子与命运符号 */}
      <div className="asc-particles">
        <div className="asc-particle p-1">✦</div>
        <div className="asc-particle p-2">✧</div>
        <div className="asc-particle p-3">⛤</div>
        <div className="asc-particle p-4">✺</div>
        <div className="asc-particle p-5">⚙</div>
        <div className="asc-particle p-6">∘</div>
        <div className="asc-particle p-7">⋆</div>
        <div className="asc-particle p-8">✧</div>
        <div className="asc-particle p-9">⌘</div>
        <div className="asc-particle p-10">∞</div>
      </div>

      <main className="asc-main">
        {/* Logo */}
        <div className="asc-logo-wrap asc-fade asc-delay-0">
          <div className="asc-logo-box">
            <span className="asc-logo-icon">📒</span>
          </div>
          <div className="asc-logo-pulse" />
        </div>

        {/* 标题 */}
        <div className="asc-heading">
          <h2 className="asc-subtitle asc-fade asc-delay-1">PERSONAL ORACLE ONLINE</h2>
          <h1 className="asc-title asc-fade asc-delay-1">小本本</h1>
          <div className="asc-brand asc-fade asc-delay-2">人生管理系统 · 正在觉醒</div>
        </div>

        {/* Slogan */}
        <div className="asc-slogan">
          <p className="asc-slogan-p asc-fade asc-delay-3">
            记录日常，观测关系，校准心智与身体。<br />
            神之途径、泛灵之网与成长数据正在归位。<br />
            <span className="asc-shimmer">把混沌生活炼成可掌控的命运地图</span>。
          </p>
          <div className="asc-slogan-line asc-fade asc-delay-3" />
          <div className="asc-status asc-fade asc-delay-4">
            <span>记忆索引校准</span>
            <span>灵感回路点亮</span>
            <span>成长路径展开</span>
          </div>
        </div>

        {/* 引导按钮 */}
        <div className="asc-cta-wrap asc-fade asc-delay-4">
          <button type="button" className="asc-cta" onClick={onEnter}>
            <span className="asc-cta-bg" />
            <span className="asc-cta-text">
              进入我的命运仪表盘
              <span className="asc-cta-arrow">→</span>
            </span>
          </button>
          <p className="asc-cta-hint">Diary · PanSpirit · Pathway · Wellness</p>
        </div>
      </main>

      {/* 边角装饰 */}
      <div className="asc-corner asc-corner-tl">XBB / ORACLE READY</div>
      <div className="asc-corner asc-corner-br">VER 3.0 // LIFE CORE SYNCED</div>

      <style>{`
        .asc-root {
          position: fixed; inset: 0; z-index: 9999;
          background:
            radial-gradient(circle at 50% 38%, rgba(139,92,246,0.24) 0%, transparent 34%),
            radial-gradient(circle at 18% 18%, rgba(6,182,212,0.16) 0%, transparent 30%),
            radial-gradient(circle at 82% 78%, rgba(245,158,11,0.12) 0%, transparent 28%),
            #020617;
          color: #f8fafc;
          font-family: 'Noto Sans SC', -apple-system, BlinkMacSystemFont, sans-serif;
          overflow-x: hidden;
          -webkit-tap-highlight-color: transparent;
        }

        .asc-noise {
          position: fixed; inset: 0; z-index: 5;
          background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
          opacity: 0.03;
          pointer-events: none;
        }

        .asc-mystic-bg {
          position: fixed; inset: 0; z-index: 0;
          display: flex; align-items: center; justify-content: center;
          opacity: 0.62; pointer-events: none;
        }
        .asc-circle {
          position: absolute;
          border: 1px solid rgba(251, 191, 36, 0.3);
          border-radius: 50%;
          aspect-ratio: 1 / 1;
          flex: 0 0 auto;
          animation: ascRotate linear infinite;
        }
        .asc-circle-1 { width: 300px; height: 300px; animation-duration: 40s; }
        .asc-circle-2 { width: 500px; height: 500px; border-style: dashed; opacity: 0.5; animation-duration: 60s; animation-direction: reverse; }
        .asc-circle-3 {
          width: 82vmin; height: 82vmin;
          max-width: 820px; max-height: 820px;
          min-width: 300px; min-height: 300px;
          aspect-ratio: 1 / 1;
          border-color: rgba(251, 191, 36, 0.16);
          animation-duration: 120s;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          background:
            conic-gradient(from 0deg, rgba(139,92,246,0), rgba(139,92,246,0.18), rgba(6,182,212,0.1), rgba(251,191,36,0.16), rgba(139,92,246,0)),
            radial-gradient(circle at center, rgba(251,191,36,0.04) 0%, rgba(251,191,36,0.01) 46%, transparent 72%);
          position: relative;
          transform-origin: center center;
        }
        .asc-vortex {
          position: absolute;
          width: 46%; height: 46%;
          border-radius: 50%;
          background:
            conic-gradient(from 90deg, transparent, rgba(6,182,212,0.22), transparent 36%, rgba(217,70,239,0.18), transparent 72%, rgba(251,191,36,0.18), transparent);
          filter: blur(0.2px);
          animation: ascMysticSpin 12s linear infinite;
          opacity: 0.72;
        }
        .asc-scan {
          position: absolute;
          width: 2px; height: 48%;
          top: 50%; left: 50%;
          transform-origin: 50% 0;
          background: linear-gradient(to bottom, rgba(103,232,249,0.9), rgba(251,191,36,0.12), transparent);
          box-shadow: 0 0 18px rgba(103,232,249,0.65);
          animation: ascSweep 5.5s linear infinite;
        }
        @keyframes ascSweep {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .asc-core-glow {
          position: absolute;
          width: 168px; height: 168px;
          background:
            radial-gradient(circle, rgba(251,191,36,0.2) 0%, rgba(139,92,246,0.12) 42%, transparent 72%);
          border-radius: 50%;
          animation: ascPulseGlow 4s ease-in-out infinite;
        }
        .asc-core-mark {
          position: absolute;
          width: 74px; height: 74px;
          border-radius: 50%;
          display: grid; place-items: center;
          color: #fef3c7;
          border: 1px solid rgba(251,191,36,0.48);
          background: radial-gradient(circle, rgba(15,23,42,0.86), rgba(2,6,23,0.42));
          box-shadow: 0 0 34px rgba(251,191,36,0.22), inset 0 0 20px rgba(139,92,246,0.24);
          animation: ascCoreBreath 3.8s ease-in-out infinite;
        }
        .asc-core-mark span {
          font-family: Georgia, 'Times New Roman', serif;
          font-size: 30px;
          line-height: 1;
          text-shadow: 0 0 18px rgba(251,191,36,0.75);
        }
        @keyframes ascCoreBreath {
          0%, 100% { transform: scale(1) rotate(0deg); opacity: 0.86; }
          50% { transform: scale(1.08) rotate(6deg); opacity: 1; }
        }
        @keyframes ascPulseGlow {
          0%, 100% { transform: scale(1); opacity: 0.5; }
          50% { transform: scale(1.5); opacity: 1; }
        }
        .asc-gear {
          position: absolute;
          width: 135%;
          height: 135%;
          fill: none;
        }
        .asc-gear-slow {
          animation: ascRotate 120s linear infinite;
        }
        .asc-gear-reverse {
          animation: ascMysticSpin 80s linear infinite reverse;
        }
        .asc-circle-3-orbit {
          position: absolute;
          width: 135%;
          height: 135%;
          fill: none;
          stroke: rgba(251,191,36,0.38);
          stroke-width: 0.55;
          animation: ascMysticSpin 95s linear infinite reverse;
        }
        .asc-rune-ring {
          position: absolute;
          inset: 0;
          border-radius: 50%;
          animation: ascMysticSpin 36s linear infinite;
        }
        .asc-rune-ring-inner {
          inset: 28%;
          animation-duration: 20s;
          animation-direction: reverse;
        }
        .asc-rune-ring span {
          position: absolute;
          left: 50%; top: 50%;
          min-width: 44px;
          margin-left: -22px;
          margin-top: -10px;
          color: rgba(226,232,240,0.62);
          font-size: 10px;
          letter-spacing: 0.12em;
          text-align: center;
          text-shadow: 0 0 10px rgba(103,232,249,0.42);
        }
        .asc-rune-ring-outer span:nth-child(1) { transform: rotate(0deg) translateY(-365px) rotate(0deg); }
        .asc-rune-ring-outer span:nth-child(2) { transform: rotate(45deg) translateY(-365px) rotate(-45deg); }
        .asc-rune-ring-outer span:nth-child(3) { transform: rotate(90deg) translateY(-365px) rotate(-90deg); }
        .asc-rune-ring-outer span:nth-child(4) { transform: rotate(135deg) translateY(-365px) rotate(-135deg); }
        .asc-rune-ring-outer span:nth-child(5) { transform: rotate(180deg) translateY(-365px) rotate(-180deg); }
        .asc-rune-ring-outer span:nth-child(6) { transform: rotate(225deg) translateY(-365px) rotate(-225deg); }
        .asc-rune-ring-outer span:nth-child(7) { transform: rotate(270deg) translateY(-365px) rotate(-270deg); }
        .asc-rune-ring-outer span:nth-child(8) { transform: rotate(315deg) translateY(-365px) rotate(-315deg); }
        .asc-rune-ring-inner span:nth-child(1) { transform: rotate(0deg) translateY(-105px) rotate(0deg); }
        .asc-rune-ring-inner span:nth-child(2) { transform: rotate(90deg) translateY(-105px) rotate(-90deg); }
        .asc-rune-ring-inner span:nth-child(3) { transform: rotate(180deg) translateY(-105px) rotate(-180deg); }
        .asc-rune-ring-inner span:nth-child(4) { transform: rotate(270deg) translateY(-105px) rotate(-270deg); }
        @keyframes ascMysticSpin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes ascRotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .asc-line-v {
          position: absolute; width: 1px; height: 100vh;
          background: linear-gradient(to bottom, transparent, rgba(251,191,36,0.2), transparent);
        }
        .asc-line-h {
          position: absolute; height: 1px; width: 100vw;
          background: linear-gradient(to right, transparent, rgba(251,191,36,0.2), transparent);
        }

        .asc-particles {
          position: fixed; inset: 0; z-index: 1; pointer-events: none; overflow: hidden;
        }
        .asc-particle {
          position: absolute;
          color: rgba(251, 191, 36, 0.25);
          animation: ascFloat linear infinite;
        }
        .p-1 { top: 15%; left: 20%; font-size: 14px; animation-duration: 25s; animation-delay: 0s; }
        .p-2 { top: 60%; left: 10%; font-size: 10px; animation-duration: 35s; animation-delay: -5s; }
        .p-3 { top: 25%; left: 80%; font-size: 18px; animation-duration: 40s; animation-delay: -10s; }
        .p-4 { top: 75%; left: 85%; font-size: 12px; animation-duration: 30s; animation-delay: -15s; }
        .p-5 { top: 85%; left: 30%; font-size: 24px; animation-duration: 45s; animation-delay: -2s; opacity: 0.15; }
        .p-6 { top: 40%; left: 90%; font-size: 8px; animation-duration: 20s; animation-delay: -8s; }
        .p-7 { top: 10%; left: 50%; font-size: 16px; animation-duration: 50s; animation-delay: -12s; }
        .p-8 { top: 80%; left: 60%; font-size: 14px; animation-duration: 28s; animation-delay: -20s; }
        .p-9 { top: 35%; left: 30%; font-size: 20px; animation-duration: 38s; animation-delay: -18s; }
        .p-10 { top: 65%; left: 70%; font-size: 16px; animation-duration: 42s; animation-delay: -7s; }

        @keyframes ascFloat {
          0% { transform: translateY(15vh) rotate(0deg) scale(0.8); opacity: 0; }
          20% { opacity: 1; }
          80% { opacity: 1; }
          100% { transform: translateY(-15vh) rotate(360deg) scale(1.2); opacity: 0; }
        }

        .asc-main {
          position: relative; z-index: 10;
          min-height: 100vh; display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          padding: 80px 24px 60px; text-align: center;
        }

        .asc-fade {
          opacity: 0;
          transform: translateY(20px);
          animation: ascFadeInUp 1s cubic-bezier(0.22, 1, 0.36, 1) forwards;
        }
        .asc-delay-0 { animation-delay: 0s; }
        .asc-delay-1 { animation-delay: 0.3s; }
        .asc-delay-2 { animation-delay: 0.6s; }
        .asc-delay-3 { animation-delay: 0.9s; }
        .asc-delay-4 { animation-delay: 1.2s; }
        @keyframes ascFadeInUp {
          to { opacity: 1; transform: translateY(0); }
        }

        .asc-logo-wrap {
          position: relative; margin-bottom: 48px;
        }
        .asc-logo-box {
          width: 80px; height: 80px;
          border-radius: 20px; border: 1px solid rgba(251,191,36,0.38);
          background: linear-gradient(145deg, rgba(15,23,42,0.72), rgba(88,28,135,0.26));
          display: flex; align-items: center; justify-content: center;
          box-shadow: 0 0 30px rgba(251,191,36,0.14), inset 0 0 26px rgba(103,232,249,0.1);
          animation: ascLogoHover 5s ease-in-out infinite;
        }
        @keyframes ascLogoHover {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-6px) rotate(3deg); }
        }
        .asc-logo-icon {
          font-size: 40px; color: #fbbf24;
        }
        .asc-logo-pulse {
          position: absolute; inset: -16px;
          border: 1px solid rgba(251,191,36,0.1);
          border-radius: 50%;
          animation: ascPulse 2s ease-in-out infinite;
        }
        @keyframes ascPulse {
          0%, 100% { opacity: 0.5; transform: scale(1); }
          50% { opacity: 0.2; transform: scale(1.02); }
        }

        .asc-heading { margin-bottom: 32px; }
        .asc-subtitle {
          font-family: Georgia, 'Times New Roman', serif;
          color: #fbbf24; letter-spacing: 0.28em;
          font-size: 12px; margin: 0 0 8px;
          text-transform: uppercase;
        }
        .asc-title {
          font-size: clamp(2.5rem, 10vw, 4rem);
          font-weight: 700; margin: 0 0 16px;
          letter-spacing: 0;
          text-shadow: 0 0 26px rgba(139,92,246,0.35);
        }
        .asc-brand {
          font-size: clamp(1rem, 3.2vw, 1.5rem);
          font-weight: 500; letter-spacing: 0.12em;
          color: #c4b5fd;
        }

        .asc-slogan {
          max-width: 520px; margin-bottom: 40px;
        }
        .asc-slogan-p {
          font-size: 18px; line-height: 1.7;
          color: #cbd5e1; font-weight: 300;
          margin: 0 0 16px;
        }
        .asc-shimmer {
          background: linear-gradient(90deg, #94a3b8, #fbbf24, #94a3b8);
          background-size: 200% auto;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-weight: 700;
          animation: ascShimmer 4s linear infinite;
        }
        @keyframes ascShimmer {
          to { background-position: 200% center; }
        }
        .asc-slogan-line {
          width: 48px; height: 1px;
          background: rgba(251,191,36,0.5);
          margin: 0 auto 16px;
        }
        .asc-slogan-tag {
          font-size: 12px; color: rgba(251,191,36,0.6);
          letter-spacing: 0.2em; margin: 0;
          text-transform: uppercase;
        }
        .asc-status {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 8px;
        }
        .asc-status span {
          padding: 6px 10px;
          border: 1px solid rgba(103,232,249,0.22);
          border-radius: 999px;
          background: rgba(15,23,42,0.46);
          color: rgba(226,232,240,0.74);
          font-size: 11px;
          letter-spacing: 0.08em;
          box-shadow: 0 0 18px rgba(6,182,212,0.08);
        }

        .asc-cta-wrap { margin-top: 0; }
        .asc-cta {
          position: relative;
          padding: 14px 36px;
          background: transparent;
          border: 1px solid rgba(251,191,36,0.58);
          border-radius: 9999px;
          overflow: hidden;
          cursor: pointer;
          transition: border-color 0.2s, box-shadow 0.2s, transform 0.2s;
          font-family: inherit;
          box-shadow: 0 0 28px rgba(251,191,36,0.1);
        }
        .asc-cta:hover {
          border-color: #fbbf24;
          box-shadow: 0 0 34px rgba(251,191,36,0.22);
          transform: translateY(-1px);
        }
        .asc-cta-bg {
          position: absolute; inset: 0;
          background: linear-gradient(90deg, rgba(139,92,246,0.28), rgba(251,191,36,0.18), rgba(6,182,212,0.22));
          transform: translateY(100%);
          transition: transform 0.3s;
        }
        .asc-cta:hover .asc-cta-bg { transform: translateY(0); }
        .asc-cta-text {
          position: relative; z-index: 1;
          color: #fbbf24; letter-spacing: 0.3em;
          font-weight: 700; font-size: 13px;
          display: inline-flex; align-items: center; gap: 8px;
        }
        .asc-cta-arrow {
          transition: transform 0.2s;
        }
        .asc-cta:hover .asc-cta-arrow { transform: translateX(4px); }
        .asc-cta-hint {
          margin-top: 20px;
          font-size: 10px; color: #64748b;
          text-transform: uppercase; letter-spacing: 0.15em;
          font-family: ui-monospace, monospace;
        }

        .asc-corner {
          position: fixed; z-index: 10;
          font-size: 10px; color: rgba(251,191,36,0.3);
          font-family: ui-monospace, monospace;
          letter-spacing: 0.15em;
        }
        .asc-corner-tl { top: 32px; left: 32px; }
        .asc-corner-br { bottom: 32px; right: 32px; }

        @media (max-width: 720px) {
          .asc-main { padding: 72px 18px 48px; }
          .asc-logo-wrap { margin-bottom: 34px; }
          .asc-slogan { max-width: 340px; margin-bottom: 34px; }
          .asc-slogan-p { font-size: 15px; line-height: 1.75; }
          .asc-brand { font-size: 14px; letter-spacing: 0.08em; }
          .asc-cta { padding: 13px 24px; max-width: 100%; }
          .asc-cta-text { font-size: 12px; letter-spacing: 0.12em; }
          .asc-corner { font-size: 9px; }
          .asc-corner-tl { top: 18px; left: 18px; }
          .asc-corner-br { right: 18px; bottom: 18px; }
          .asc-rune-ring-outer span { display: none; }
          .asc-circle-1 { width: 260px; height: 260px; }
          .asc-circle-2 { width: 420px; height: 420px; }
          .asc-circle-3 {
            width: 88vmin;
            height: 88vmin;
            min-width: 280px;
            min-height: 280px;
          }
          .asc-gear,
          .asc-circle-3-orbit {
            width: 128%;
            height: 128%;
          }
        }
      `}</style>
    </div>
  );
};

export default AscensionSplash;
